module.exports = __webpack_public_path__ + "img/tropical-storm-tracks.1089a2f9.png";